import React from 'react';

const ICON_STROKE = 1.8;

const ICONS = {
  dashboard: (
    <>
      <path d="M3 13.5h8.5V3H3z" />
      <path d="M12.5 21H21v-11.5h-8.5z" />
      <path d="M12.5 10.5H21V3h-8.5z" />
      <path d="M3 21h8.5v-5.5H3z" />
    </>
  ),
  projects: (
    <>
      <path d="M3 7.5h18v12A1.5 1.5 0 0 1 19.5 21h-15A1.5 1.5 0 0 1 3 19.5z" />
      <path d="M9 7.5V6a1.5 1.5 0 0 1 1.5-1.5h3A1.5 1.5 0 0 1 15 6v1.5" />
    </>
  ),
  tasks: (
    <>
      <path d="M8.5 7h12" />
      <path d="M8.5 12h12" />
      <path d="M8.5 17h12" />
      <path d="M4 7h.01" />
      <path d="M4 12h.01" />
      <path d="M4 17h.01" />
    </>
  ),
  puantaj: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3.4 2.1" />
    </>
  ),
  photos: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <circle cx="8.5" cy="10" r="1.5" />
      <path d="m21 15-4.3-4.3a1 1 0 0 0-1.4 0L10 16" />
      <path d="m13.5 19 2.2-2.2a1 1 0 0 1 1.4 0L19.5 19" />
    </>
  ),
  dailyReports: (
    <>
      <path d="M7 3.5h10A2.5 2.5 0 0 1 19.5 6v12A2.5 2.5 0 0 1 17 20.5H7A2.5 2.5 0 0 1 4.5 18V6A2.5 2.5 0 0 1 7 3.5z" />
      <path d="M8.5 8.5h7" />
      <path d="M8.5 12h7" />
      <path d="M8.5 15.5h4" />
    </>
  ),
  checklists: (
    <>
      <path d="M8.5 7.5H20" />
      <path d="M8.5 12H20" />
      <path d="M8.5 16.5H20" />
      <path d="m4 7.4 1.4 1.4 2.4-2.6" />
      <path d="m4 11.9 1.4 1.4 2.4-2.6" />
      <path d="m4 16.4 1.4 1.4 2.4-2.6" />
    </>
  ),
  changeOrders: (
    <>
      <path d="M6 4.5h9l4 4V19a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 19V6A1.5 1.5 0 0 1 6.5 4.5z" />
      <path d="M15 4.5V9h4" />
      <path d="M8.2 12h7.6" />
      <path d="M8.2 15.2h5.8" />
    </>
  ),
  operationsCenter: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5v4.5l3 1.8" />
      <path d="M12 3.5v2" />
      <path d="M20.5 12h-2" />
      <path d="M12 20.5v-2" />
      <path d="M3.5 12h2" />
    </>
  ),
  teams: (
    <>
      <circle cx="8.5" cy="9" r="2.3" />
      <circle cx="15.5" cy="8" r="1.9" />
      <path d="M4 17.8c0-2.3 2-4.1 4.5-4.1s4.5 1.8 4.5 4.1" />
      <path d="M13.3 17.8c0-1.9 1.6-3.4 3.7-3.4 2 0 3.7 1.5 3.7 3.4" />
    </>
  ),
  resources: (
    <>
      <path d="M12 3.5 4 7.8V16l8 4.5 8-4.5V7.8z" />
      <path d="m4 7.8 8 4.5 8-4.5" />
      <path d="M12 12.3V20.5" />
    </>
  ),
  users: (
    <>
      <circle cx="12" cy="8.5" r="3.2" />
      <path d="M5 20c0-3.3 3.1-5.8 7-5.8s7 2.5 7 5.8" />
    </>
  ),
  reports: (
    <>
      <path d="M5 4.5h10l4 4V19a1.5 1.5 0 0 1-1.5 1.5h-12A1.5 1.5 0 0 1 4 19V6A1.5 1.5 0 0 1 5.5 4.5z" />
      <path d="M15 4.5V9h4" />
      <path d="M8 13h8" />
      <path d="M8 16h6" />
    </>
  ),
  finance: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 10.5h18" />
      <path d="M7.5 15.5h2.5" />
      <path d="M12.5 15.5H16.5" />
    </>
  ),
  settings: (
    <>
      <path d="M12 8.8a3.2 3.2 0 1 0 0 6.4 3.2 3.2 0 0 0 0-6.4z" />
      <path d="M19.4 12a7.6 7.6 0 0 0-.1-1.2l2-1.5-1.9-3.3-2.4 1a8 8 0 0 0-2.1-1.2l-.4-2.6h-3.8l-.4 2.6a8 8 0 0 0-2.1 1.2l-2.4-1-1.9 3.3 2 1.5A7.6 7.6 0 0 0 4.6 12c0 .4 0 .8.1 1.2l-2 1.5 1.9 3.3 2.4-1c.7.5 1.4.9 2.1 1.2l.4 2.6h3.8l.4-2.6c.7-.3 1.4-.7 2.1-1.2l2.4 1 1.9-3.3-2-1.5c.1-.4.1-.8.1-1.2z" />
    </>
  ),
  bell: (
    <>
      <path d="M17.2 13.8V10a5.2 5.2 0 1 0-10.4 0v3.8L5 16.2h14z" />
      <path d="M10 19a2 2 0 0 0 4 0" />
    </>
  ),
  admin: (
    <>
      <path d="M12 3.5 19 7v5.8c0 4.1-2.7 6.6-7 7.7-4.3-1.1-7-3.6-7-7.7V7z" />
      <path d="m9.1 12 1.8 1.8 3.8-3.9" />
    </>
  ),
  plus: (
    <>
      <path d="M12 5v14" />
      <path d="M5 12h14" />
    </>
  ),
  menu: (
    <>
      <path d="M4 7.5h16" />
      <path d="M4 12h16" />
      <path d="M4 16.5h16" />
    </>
  ),
  chevronLeft: <path d="m14.5 6-5 6 5 6" />,
  chevronRight: <path d="m9.5 6 5 6-5 6" />,
  construction: (
    <>
      <path d="M6 14h12" />
      <path d="M8 14v5h8v-5" />
      <path d="M7 10.5h10l-1.8-5H8.8z" />
      <path d="M4.5 19.5h15" />
    </>
  ),
  active: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="m8 12 2.4 2.4L16 8.8" />
    </>
  ),
  completed: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="m8 12.3 2.3 2.2 5.7-5.7" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 10.2v5.6" />
      <path d="M12 7.5h.01" />
    </>
  ),
};

const AppIcon = ({ name, className = '', title = '' }) => {
  const icon = ICONS[name];
  if (!icon) return null;

  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={ICON_STROKE}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={title ? undefined : 'true'}
      role={title ? 'img' : 'presentation'}
    >
      {title ? <title>{title}</title> : null}
      {icon}
    </svg>
  );
};

export default AppIcon;
